import { render, staticRenderFns } from "./warranty.vue?vue&type=template&id=e4d16d5c&scoped=true"
import script from "./warranty.vue?vue&type=script&lang=js"
export * from "./warranty.vue?vue&type=script&lang=js"
import style0 from "./warranty.vue?vue&type=style&index=0&id=e4d16d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d16d5c",
  null
  
)

export default component.exports